import { action as toggleMenu } from 'redux-burger-menu';

export const toggle = () => {
  return async (dispatch, getState) => {
    const { isOpen } = getState().burgerMenu;
    return dispatch(toggleMenu(!isOpen));
  };
};
